import './Collaborators.scss';

import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Button } from '@mui/material';
import {IconButton, Tooltip } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import DialogValiderCollab from '../../../Components/Dialogs/DialogValiderCollab';
import { buttonStylesGreen } from '../../../Components/docsAdministrative/JsObjectStyles';
import { ChipRoleCollab, MaterialTableComponent, NomEmail } from '../../../Components/shared/ReusableSmallComponents';
import { ROLES } from '../../../config';
import useAdminRoleCompanyName from '../../../hooks/useAdminRoleCompanyName';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import usePostRequest from '../../../hooks/usePostRequest';
import useRole from '../../../hooks/useRole';
import useUtilities from '../../../hooks/useUtilities';
import { searchDuplicateClient, statutCollaborateur, verifySignataire } from '../../../Utils/utils';
import ChangeStatutCollaborateur from './ChangeStatutCollaborateur';
import EditerCollab from './EditerCollab';

function Collaborators() {
    const { i18n } = useTranslation();
    const {postData} = usePostRequest();
    const axiosPrivate = useAxiosPrivate();
    const [clientRole, companyName,signataire] = useAdminRoleCompanyName();
    //console.log('useAdminRoleCompanyName', useAdminRoleCompanyName());
    //console.log('clientRole', clientRole);
    //console.log('companyName', companyName);
    const [dataCollaborateur, setdataCollaborateur] = useState([]);
    const { setBackdropOpen } = useUtilities();
    const [permission, setPermission] = useState('');
    const [open, setOpen] = useState(false);
    const role=useRole();
    //const [data,setData]=useState();

    useEffect(() => {
        console.log('clientRole',clientRole);
        if (clientRole?.Admin == 1 || clientRole?.littleAdmin == 1) {
            setPermission('edit');
        }
    }, [clientRole]);

    useEffect(() => {
        if(role)
            getMyCollaborators();
    }, [role]);

    useEffect(() => {
        if(dataCollaborateur)
            console.log('dataCollaborateur',dataCollaborateur);
    }, [dataCollaborateur]);

    //useEffect(() => {
    //    if(data){
    //        let temp=[];
    //        let index;
    //        console.log('data',data);
    //        console.log('data?.invitations',data?.invitations);
    //        temp = searchDuplicateClient(data?.invitations,data?.Comptables, temp);
    //        temp = searchDuplicateClient(data?.invitations,data?.Managers, temp);
    //        temp = searchDuplicateClient(data?.invitations,data?.ResponsableAchats, temp);
    //        temp = searchDuplicateClient(data?.invitations,data?.Rhs, temp);
    //        temp = searchDuplicateClient(data?.invitations,data?.littleAdmins, temp);
    //        temp = searchDuplicateClient(data?.invitations,[data?.adminId], temp);
    //        data?.invitations.forEach(element => {
    //            index = temp.findIndex(object => object?.email_ === element?.email);
    //            console.log('email',element?.email,'statut',statutCollaborateur(element?.accepted, element?.wasInvitedToJoin,element?.collaboratorData?.isActive));
    //            if (index === -1) {
    //                temp.push({ 'id': element?._id, 'img': element?.collaboratorData?.collaboratorId?.persoData?.photo, 'statut': statutCollaborateur(element?.accepted, element?.wasInvitedToJoin,element?.collaboratorData?.isActive), 'role': '', 'tele': element?.collaboratorData?.collaboratorId?.persoData?.tele, 'nom': element?.collaboratorData?.collaboratorId?.persoData?.nom, 'prenom': element?.collaboratorData?.collaboratorId?.persoData?.prenom, 'email_': element?.email, 'nom_': element?.collaboratorData?.collaboratorId?.persoData?.nom + ',' + element?.collaboratorData?.collaboratorId?.persoData?.email });
    //            }
    //        });
    //        console.log('temp temp',temp);
    //        setdataCollaborateur(temp);
    //    }
    //}, [data]);

    const getMyCollaborators = async () => {
        setBackdropOpen(true);
        try {
            const response = await axiosPrivate.get(`/${role}/getMyCollaborators`); //already has the same effect as /getInvitations
            //setData(response?.data);
            //console.log('response data', response?.data);
            let temp=[];
            let index;
            console.log('dataa',response?.data);
            //console.log('data?.invitations',data?.invitations);
            temp = searchDuplicateClient(response?.data?.invitations,response?.data?.Comptables, temp);
            if(role!='esn'){
                temp = searchDuplicateClient(response?.data?.invitations,response?.data?.Managers, temp);
                temp = searchDuplicateClient(response?.data?.invitations,response?.data?.ResponsableAchats, temp);
                temp = searchDuplicateClient(response?.data?.invitations,response?.data?.Rhs, temp);
            }
            else
                temp = searchDuplicateClient(response?.data?.invitations,response?.data?.Commercials, temp);
            temp = searchDuplicateClient(response?.data?.invitations,response?.data?.littleAdmins, temp);
            temp = searchDuplicateClient(response?.data?.invitations,[response?.data?.adminId], temp);

            response?.data?.invitations.forEach(element => {
                index = temp.findIndex(object => object?.email_ === element?.email);
                //console.log('email',element?.email,'statut',statutCollaborateur(element?.accepted, element?.wasInvitedToJoin,element?.collaboratorData?.isActive));
                if (index === -1) {

                    temp.push({
                        'id': element?._id,
                        'img': role!='esn'? element?.collaboratorData?.collaboratorId?.persoData?.photo:element?.collaboratorData?.collaboratorEsnId?.persoData?.photo,
                        'statut': statutCollaborateur(element?.accepted, element?.wasInvitedToJoin,element?.collaboratorData?.isActive),
                        'role':element?.collaboratorData?.collaboratorId?.roles,
                        'signataire':verifySignataire(signataire,element?.collaboratorData?.collaboratorEsnId?._id),
                        'tele':role!='esn'? element?.collaboratorData?.collaboratorId?.persoData?.tele : element?.collaboratorData?.collaboratorEsnId?.persoData?.tele,
                        'nom': role!='esn'?element?.collaboratorData?.collaboratorId?.persoData?.nom : element?.collaboratorData?.collaboratorEsnId?.persoData?.nom,
                        'prenom':role!='esn'? element?.collaboratorData?.collaboratorId?.persoData?.prenom: element?.collaboratorData?.collaboratorEsnId?.persoData?.prenom,
                        'email_':element?.email,
                        isBlocked: element?.collaboratorData?.isBlocked ?? false,
                        'nom_': role!='esn'? (element?.collaboratorData?.collaboratorId?.persoData?.nom + ',' + element?.collaboratorData?.collaboratorId?.persoData?.email):
                            (element?.collaboratorData?.collaboratorEsnId?.persoData?.nom + ',' + element?.collaboratorData?.collaboratorEsnId?.persoData?.email),
                        ...element
                    });
                }
            });
            console.log('temp temp',temp);
            setdataCollaborateur(temp);
            setBackdropOpen(false);
        }

        catch (error) {
            console.log(error);
            setBackdropOpen(false);
        }
    };

    const renovoyerInv = async (rowData) => {
        try {
            const response = await postData({
                url: `${role}/inviteCollaboratorByClientOwner`, payload: {
                    role: role !== 'esn' ? ROLES.Client : ROLES.Esn,
                    email:rowData?.email_, nom:rowData?.nom, prenom:rowData?.prenom, tele:rowData?.tele,
                }
            });
            console.log(response.data);
        } catch (error) {
            console.log(error);
        }

    };

    const columns = [
        {
            field: 'nom',
            title: i18n.t('Nom'),
            render: rowData =>
                <NomEmail
                    nom={rowData?.nom}
                    prenom={rowData?.prenom}
                    email={rowData?.email_}
                />
        },
        {
            field: 'role',
            title: i18n.t('Rôle'),
            render: rowData => {
                return (
                    <>
                        <ChipRoleCollab rowSelected={rowData} />
                    </>

                );
            }
        },
        //170px valeur avant
        {
            field: 'statut',
            title: i18n.t('Statut'),
            render: rowData => {
                return (
                    <div style={{display: 'flex', flexDirection: 'raw',gap:'8px'}}>
                        <ChangeStatutCollaborateur
                            width={'150px'}
                            rowSelected={rowData}
                            mode={permission}
                            getMyCollaborators={getMyCollaborators}
                            defaultStatusCollab={rowData?.statut}
                        />
                        {rowData?.isBlocked &&
                            <BlockOutlinedIcon style={{color :'red',margin:'5px'}}/>
                        }
                        {(role == 'esn' && rowData?.statut=='enAttente') &&
                            <Tooltip title={i18n.t('Renvoyer une invitation')}>
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    onClick={() => renovoyerInv(rowData)}
                                    aria-label="close"
                                >
                                    <RefreshIcon />
                                </IconButton>
                            </Tooltip>
                        }
                    </div>

                );
            }
            //render: rowData =>
            //    rowData?.statut,

        },
        //{
        //    field: 'statut',
        //    title: i18n.t('statut 2',
        //    //render: rowData =>
        //    //    rowData?.statut,

        //},
        {
            field: 'edit',
            title: i18n.t('Options'),
            render: rowData => {
                return (
                    <EditerCollab
                        rowSelected={rowData}
                        getMyCollaborators={getMyCollaborators}
                    />
                );
            }
        }
    ];
    //const [selectedRow, setSelectedRow] = useState(null);

    return (
        <>
            <div
                style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', alignSelf: 'stretch', gap: '24px' }}
            >
                <div className='frame5Profile' > {i18n.t('Compte entreprise')} &gt;
                    <span style={{ color: 'rgba(39, 45, 60, 1)' }}>
                        {i18n.t('Collaborateurs')} {companyName} </span>
                </div>
                <div className='frame1Collaborators' >
                    <div className='frame2Collaborators' >
                        <h4
                            className='titlesociete'
                        > {i18n.t('Collaborateurs')} {companyName}
                        </h4>
                    </div>
                    {
                        permission == 'edit' &&
                        <div style={{ alignSelf: 'stretch', display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                onClick={() => setOpen(true)}
                                variant='contained'
                                style={{...buttonStylesGreen(false)}}
                            >
                                {i18n.t('Ajouter un collaborateur')}
                            </Button>
                        </div>
                    }
                    <MaterialTableComponent
                        columns={columns}
                        data={dataCollaborateur}
                        title={i18n.t('Collaborateurs')}
                        //onRowClick={(event, rowData) => {
                        //    setSelectedRow(rowData?.tableData.id);
                        //}}
                        //selectedRow={selectedRow}
                    />
                </div>
                {open &&
                    <DialogValiderCollab
                        open={open}
                        setOpen={setOpen}
                        title={'Ajouter un collaborateur'}
                        mode={'ajouter'}
                        getMyCollaborators={getMyCollaborators}
                    />}
            </div>
        </>
    );
}

export default Collaborators;